import * as io from "io-ts";
import t from "../../../../../../i18n";
import createGlobalState from "@ui/lib/createGlobalState";

export const orderingOptions = [
  {
    label: t("reporting.title.failures.order.impact"),
    value: "FAILURE_ORDERING",
  },
  {
    label: t("reporting.title.failures.order.alphabetical"),
    value: "ALPHABETICAL_ORDERING",
  },
] as const;

export const useOrdering = createGlobalState({
  storage: "session",
  key: "reportingProjectOrdering",
  type: io.union([io.literal(orderingOptions[0].value), io.literal(orderingOptions[1].value)]),
  defaultValue: orderingOptions[0].value,
  scoped: false,
});
